import { GridFiltersController } from '../controller/GridFiltersController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { ColumnDetails } from '../../types/common';
import { Filter } from '../types';
import { GridBaseDataProvider } from '../../GridBaseDataProvider';
import { GridFilterUiConfiguration } from '../../../types/filters/types';

export class GridFiltersWebComponent<Column extends number, ColumnKeys extends string> extends BaseWebComponentElement {
  private dataProviderRef: GridBaseDataProvider<Column, ColumnKeys>;
  private _smartViewsEnabled: boolean;
  private _filtersUiConfigs: Array<GridFilterUiConfiguration> = [];
  private _filterDependencyMapping?: ColumnDetails<Column, ColumnKeys>;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: GridFiltersController,
    });
  }

  get viewId(): string {
    const value = this.getAttribute('data-view-id');
    return value ? value : '';
  }

  set viewId(value: string) {
    this.setAttribute('data-view-id', value);
  }

  get allColumnDetails(): ColumnDetails<Column, ColumnKeys>[] {
    return this.getArrayValueFromAttribute(this, 'data-all-column-details', 'allColumnDetails');
  }

  set allColumnDetails(value: ColumnDetails<Column, ColumnKeys>[]) {
    this.setAttribute('data-all-column-details', JSON.stringify({ allColumnDetails: value }));
  }

  set filterDependencyMapping(value) {
    this._filterDependencyMapping = value;
  }

  get filterDependencyMapping() {
    return this._filterDependencyMapping;
  }

  get filters(): Filter<ColumnKeys>[] {
    return this.getArrayValueFromAttribute(this, 'data-filters', 'filters');
  }

  set filters(value: Filter<ColumnKeys>[]) {
    this.setAttribute('data-filters', JSON.stringify({ filters: value }));
  }

  set predefinedFiltersKeys(value: ColumnKeys[]) {
    this.setAttribute('data-predefined-filters', JSON.stringify({ predefinedFiltersKeys: value }));
  }

  get predefinedFiltersKeys(): ColumnKeys[] {
    return this.getArrayValueFromAttribute(this, 'data-predefined-filters', 'predefinedFiltersKeys');
  }

  /**
   * This is a flag to optionally hide the 'Reset filters' button if the grid has more than two filters.
   * @param value
   */
  set hideResetFilters(value: boolean) {
    value ? this.setAttribute('hideResetFilters', '') : this.removeAttribute('hideResetFilters');
  }

  get hideResetFilters(): boolean {
    return this.hasAttribute('hideResetFilters');
  }

  set dataProvider(value: GridBaseDataProvider<Column, ColumnKeys>) {
    this.dataProviderRef = value;
  }

  get dataProvider(): GridBaseDataProvider<Column, ColumnKeys> {
    return this.dataProviderRef;
  }

  set smartViewsEnabled(value: boolean) {
    this._smartViewsEnabled = value;
  }

  get smartViewsEnabled(): boolean {
    return this._smartViewsEnabled ?? false;
  }

  set filtersUiConfigs(value: GridFilterUiConfiguration[]) {
    this._filtersUiConfigs = value;
  }

  get filtersUiConfigs(): GridFilterUiConfiguration[] {
    return this._filtersUiConfigs;
  }

  resetCompanyFilter(): void {
    if (!this.controller || !this.controller.view.dom.$companyFilter) {
      return;
    }

    this.controller.view.dom.$companyFilter.filterOptions = [];
  }
}
